import * as $ from 'jquery'
import store from '../../js/store';

const navActiveClass = 'app--nav-active',
      navDesktopClass = 'app--nav-desktop',
      navMobileClass = 'app--nav-mobile',
      searchActiveClass = 'app--search-active';

const navSelector = '#site-nav',
      $nav = $(navSelector),
      $siteHead = $('#site-head > .wrap'),
      $siteSearch = $('#site-search');

const toggleSelector = '#site-nav__toggle',
      $toggle = $(toggleSelector);

let viewportWidth = 0,
    width         = 0;

function debounce(func) {
  var wait = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];

  var timeout = void 0;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(_this, args);
    }, wait);
  };
}

store.isMobileNav = store.isMobileNav || false;

const toggleMenu = (function(open = true, preventScrollChange = false) {
  if(open) {

    $(toggleSelector).attr({'aria-pressed': 'true', 'aria-label': 'Close Menu'});
    store.$app.addClass(navActiveClass);

    if(!store.$app.hasClass('flag--nav-2020')) {
      toggleSearch(false);
    }

    //disableScroll();

    $siteSearch.removeClass('active');
    $nav.attr('aria-hidden', 'false');

    if(store.isMobileNav) {
      $('#site-main, #site-foot').attr({'aria-hidden': 'true'});
    }

  } else {

    $(toggleSelector).attr({'aria-pressed': 'false', 'aria-label': 'Open Menu'});
    store.$app.removeClass(navActiveClass);

    //enableScroll(preventScrollChange);

    $('#site-main, #site-foot').attr('aria-hidden', 'false');

    if(store.isMobileNav) {
      $nav.attr({'aria-hidden': 'false'});
    }

    if(store.$app.hasClass('flag--nav-2020')) {
      toggleSearch(false);
    }
  }
});

const setNavClass = (function(mobile = false) {
  store.$app.addClass(mobile ? navMobileClass : navDesktopClass);
  store.$app.removeClass(mobile ? navDesktopClass : navMobileClass);

  $toggle.attr('aria-hidden', !mobile);

  toggleMenu(false, true);
});

const checkNavSize = (function(e, forceCheck = false) {
  if(viewportWidth === window.innerWidth && !forceCheck) { return false; }

  setNavClass();

  const siteHeadWidth = parseInt($siteHead.width());
  width = 0;

  $siteHead.children(':visible').not('.super, .site-search').each((i, elem) => {
    width += parseInt($(elem).innerWidth());

    console.log({ elem, width: $(elem).innerWidth()});
  });

  console.log({siteHeadWidth, width});

  store.isMobileNav = width > siteHeadWidth;

  setNavClass(store.isMobileNav);
  viewportWidth = window.innerWidth;
});

$('.site-nav__mega-menu .menu-item-object-support-category').first().addClass('active');

const toggleSearch = (function(open = true) {
  if(open) {

    if(!store.$app.hasClass('flag--nav-2020')) {
      toggleMenu(false)
    }
    store.$app.addClass(searchActiveClass);

    setTimeout(() => {
      $('input[type="search"]', $siteSearch).focus();
    }, 250);

  } else {

    store.$app.removeClass(searchActiveClass);

  }
});

store.$app.on('click', '.site-search__toggle', function(e) {
  e.preventDefault();

  const active = $siteSearch.hasClass('active');
  toggleSearch(!store.$app.hasClass(searchActiveClass));

});

store.$app.on('mouseenter', '.site-nav .menu-item-has-children', function() {
  $('.site-nav li').removeClass('open-sub-nav');
  $(this).addClass('open-sub-nav');
});

store.$app.on('mouseleave', '.site-nav .menu-item-has-children', function() {
  $('.site-nav li').removeClass('open-sub-nav');
});

store.$app.on('mouseenter', '.site-nav__mega-menu .menu-item-object-support-category:not(.active)', function(e) {
  $('.site-nav__mega-menu .sub-menu li.active').removeClass('active');
  $(this).addClass('active');
})

store.$app.on('click', toggleSelector, function(e) {
    e.preventDefault();
    toggleMenu(!store.$app.hasClass(navActiveClass));
});


checkNavSize(null, true);
var debounced = debounce(checkNavSize, 500);
window.addEventListener('resize', debounced);
//store.$window.on('resize', debounce(checkNavSize(),100));
// store.webFontLoaded.push([checkNavSize, [null, true]]);
